const InstituteOnboarding = {
    "institute_onboarding": "Institute Onboarding",
    "search": "Search",
    "table_institute": "INSTITUTE",
    "table_institute_code": "CODE",
    "table_institute_type": "TYPE",
    "table_owner": "OWNER",
    "table_email": "EMAIL",
    "table_phone": "PHONE",
    "table_user_code": "USER CODE",
    "table_role": "ROLE",
    "table_branch_type": "BRANCH TYPE",
    "table_payment_status": "PAYMENT",
    "table_onboarding_status": "ONBOARDING",
}

export default InstituteOnboarding;
